(function () {
    'use strict';

    function documentUploadGroupConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/documentUploadGroupConfiguration.html',
            link: function (scope) {

            }
        };
    }

    documentUploadGroupConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('documentUploadGroupConfiguration', documentUploadGroupConfiguration);
})();
